export default (value, {target, inclusion = false, format = 'YYYY-MM-DD HH:mm:ss'}, validator, fieldName) => {
    let parsed = moment(value, format, true)

    if( ! parsed.isValid() ) {
        return {
            result: false,
            message: validator.$errorMessages[ '_invalid_format' ]( fieldName, {format} )
        }
    }

    if( validator.form().has(target) ) {
        target = validator.form().get(target)
    }

    target = moment(target)

    if( ! target.isValid()) {
        return false
    }

    return inclusion
                ? parsed.isSameOrBefore(target)
                : parsed.isBefore(target)
}
